import { useEffect, useRef } from "react";

import { useFieldValue } from "2g-form";
import { useFormActions } from "2g-form/hooks";

export default function useContentRenderer({ index, isSelected, selection }) {
  const inputRef = useRef();
  const isSelectionStart = isSelected && index === selection.from;
  const actions = useFormActions();
  const defaultMzo = useFieldValue(`defaultMzo`);
  const defaultVzo = useFieldValue(`defaultVzo`);
  const fixniNarokyValue = useFieldValue("fixniNaroky");

  const updateNaroky = field => {
    if (isSelectionStart && selection.to !== undefined && fixniNarokyValue) {
      const naroky = [...fixniNarokyValue];
      const actual = naroky[index][field];

      for (let i = index + 1; i <= selection.to; i++) {
        naroky[i] = { ...naroky[i], [field]: actual };
      }
      actions.setValue("fixniNaroky", naroky);
    }
  };

  useEffect(() => {
    updateNaroky("mzo");
  }, [fixniNarokyValue?.[index]?.mzo]);

  useEffect(() => {
    updateNaroky("vzo");
  }, [fixniNarokyValue?.[index]?.vzo]);

  useEffect(() => {
    if (selection && index === selection.from) {
      inputRef.current?.focus();
      inputRef.current?.select();
      inputRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [index, selection?.from, selection?.to]);

  return {
    defaultMzo,
    defaultVzo,
    inputRef,
    showPlaceholder: !fixniNarokyValue?.[index]
  };
}
